/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_Source_MiniappInputs */

const vi_shop_account_source_miniapp = /** @type {(inputs: Shop_Account_Source_MiniappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zalo Mini App`)
};

/**

* @param {Shop_Account_Source_MiniappInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_source_miniapp = /** @type {((inputs?: Shop_Account_Source_MiniappInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_Source_MiniappInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_source_miniapp(inputs)
});